export default {
  eventInfo: { day: 0, month: 'curr' },
  lastVisitedMonthValue: 0
};
